interface Props {
  seasonName: string
  cost: number
  playerShards: number
  themeColor: string
  onConfirm: () => void
  onClose: () => void
  pending: boolean
}

export default function PurchasePassModal({ seasonName, cost, playerShards, themeColor, onConfirm, onClose, pending }: Props) {
  const canAfford = playerShards >= cost

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black bg-opacity-70 px-4 pb-6">
      <div
        className="w-full max-w-md rounded-2xl p-6 space-y-5"
        style={{ background: '#0D1525', border: `1px solid ${themeColor}40` }}
      >
        <div className="text-center">
          <p className="font-display font-black text-2xl text-ab-text mb-1">{seasonName}</p>
          <p className="text-label text-sm opacity-60">Battle Pass</p>
        </div>

        <div className="space-y-3 text-sm">
          {[
            'Access all premium tier rewards retroactively',
            'Season-exclusive creatures and skins',
            'Premium titles and cosmetic unlocks',
            'Battle Pass never expires during the season',
          ].map(f => (
            <div key={f} className="flex items-center gap-2">
              <span style={{ color: themeColor }}>✓</span>
              <span className="text-body opacity-80">{f}</span>
            </div>
          ))}
        </div>

        <div
          className="rounded-xl p-4 flex items-center justify-between"
          style={{ background: `${themeColor}15`, border: `1px solid ${themeColor}30` }}
        >
          <div>
            <p className="font-display font-bold text-sm text-ab-text">Cost</p>
            <p className="text-body text-xs opacity-60">Your balance: {playerShards.toLocaleString()} 💎</p>
          </div>
          <p className="font-display font-black text-2xl" style={{ color: themeColor }}>
            {cost} 💎
          </p>
        </div>

        {!canAfford && (
          <p className="text-center text-xs" style={{ color: '#FF4800' }}>
            Not enough Shards. Earn more by completing challenges.
          </p>
        )}

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 rounded-xl font-display font-bold text-sm text-ab-text-dim bg-white bg-opacity-5 border border-white border-opacity-10"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={!canAfford || pending}
            className="flex-1 py-3 rounded-xl font-display font-black text-sm transition-opacity disabled:opacity-40"
            style={{ background: themeColor, color: '#020510' }}
          >
            {pending ? 'Processing…' : 'Unlock Pass'}
          </button>
        </div>
      </div>
    </div>
  )
}
